import { Campaigns } from '../../campaigns';
import type { ModernSubscription } from '../../types';
import type { CampaignType } from '../campaigns/types';

export function getEnterpriseCampaign(modernSubscription: ModernSubscription) {
  const _campaigns = modernSubscription.campaigns as undefined | { [key: string]: CampaignType };
  // the campaign name gets transformed to lowercase
  if (_campaigns) {
    return _campaigns[Campaigns.ENTERPRISE];
  }

  return;
}
